import { ToastService } from "../../services/toast.service";
import { Form, Button, Col, Row, Spinner, Alert } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import AuthService from "../../services/auth.service";
import UtilService from "../../services/util.service";
import { UserCredentialsModel } from "../../models/userCredentials";
import { ResultRequestModel } from "../../models/resultRequest.model";
import storageService from "../../services/storage.service";
import { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import * as yup from 'yup';
import i18n from 'i18next';
import './index.css';
import { setDefaultLocale } from "react-datepicker";
import BdpVersionService from "../../services/bdpversion.service";
import { BdpVersionModel } from './../../models/bdpVersion.model';
import { VERSION_FRONT } from '../../constants/version';
import appsettings from '../../configs/appsettings.json';
import { CustomModal } from "../../components/Modal";
import { ModalChangePassword } from "../../components/ModalChangePassword";
import moment from "moment";
import UserPreferenceService from "../../services/userPreference.service";
import { saveAs } from 'file-saver';

const Login = () => {
  const user = storageService.getUser();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const history = useHistory();
  const [front_Version, setFrontVersion] = useState("0");
  const [back_Version, setBackVersion] = useState("0");
  const [banco_Version, setBancoVersion] = useState("0");
  const [sprint_Version, setSprintVersion] = useState("0");
  const [loaded, setLoaded] = useState(false);
  const [showModalChangePassword, setShowModalChangePassword] = useState(false);

  const [alertVersion, setAlertVersion] = useState([]);

  const [showWarning, setShowWarning] = useState({
    show: false,
    params: [],
    admin: false
  });

  const handleClosePasswordChanging = () => {
    setShowModalChangePassword(false);
    handleCloseWarning();
  }

  const ChangePassword = async () => {
    setShowModalChangePassword(true);
  }

  const handleCloseWarning = () => {
     // Verifica o profileName do usuário
      const profileName = user?.profile.profileName;
      console.log("login profile 1", profileName);
    // Verifica se homePagePreference está armazenado no localStorage
    const homePagePreference = localStorage.getItem('homePagePreference');

    // Decide para qual página redirecionar com base no valor de homePagePreference
    if (profileName === "approver") {
      // Redireciona para a rota do aprovador
      history.push('/ApproverPickup');
    } else {
      // Verifica se homePagePreference está armazenado no localStorage
      const homePagePreference = localStorage.getItem('homePagePreference');
  
      // Decide para qual página redirecionar com base no valor de homePagePreference
      if (homePagePreference === '1') {
        history.push('/DashboardBranch');
      } else {
        if(profileName === 'operator') {
          history.push('/DashboardBranch');
        } else {
          history.push('/');
        }
      }
    }

    // Limpa o estado do aviso
    setShowWarning({ show: false, params: [], admin: false });
  }

  const loginRequest = (user: UserCredentialsModel) => {

    setLoading(true);
    AuthService
      .login(user)
      .then((response: ResultRequestModel) => {
        if (response.success) {
          UserPreferenceService.ByUserId(0).then((userPreferenceResponse: any) => {
            if (userPreferenceResponse) {
              //console.log("userPreferenceResponse", userPreferenceResponse)
              // Se a chamada da API for bem-sucedida, armazene as informações no localStorage
              localStorage.setItem('hideFilterDashboard', userPreferenceResponse.hideFilterDashboard.toString());
              localStorage.setItem('homePagePreference', userPreferenceResponse.homePagePreference.toString());
            } else {
              // Se houver algum erro na chamada da API, setar as informações para default
              localStorage.setItem('hideFilterDashboard', 'false');
              localStorage.setItem('homePagePreference', '0');
            }
          })
          storageService.setUserLoggedIn(response.result);
          setDefaultLocale(response.result.user.idiom.shortName.replaceAll('-', ''));
          i18n.changeLanguage(response.result.user.idiom.shortName, (err, t) => {
            if (err) return console.log('something went wrong loading', err);
          });
          if (response.result.daysToExpire > -9999) {
            setShowWarning({
              show: true,
              params: [response.result.daysToExpire],
              admin: (response.result.user.profile.profileName === "admin" ||
                response.result.user.profile.profileName === "controller" ||
                response.result.user.profile.profileName === "core" ||
                response.result.user.profile.profileName === "ctry_admin"
              )
            });
          }
          else {
            //console.log("Entrando aqui")
            if (response.result.user.profile.profileName === "admin" ||
              response.result.user.profile.profileName === "controller" ||
              response.result.user.profile.profileName === "operator" ||
              response.result.user.profile.profileName === "core" ||
              response.result.user.profile.profileName === "ctry_admin" ||
              response.result.user.profile.profileName === "reader" ||
              response.result.user.profile.profileName === "adm_reader" ||
              response.result.user.profile.profileName === "sys_admin"
            ) {

              // Chama o serviço e pega a preferência do usuário
              UserPreferenceService.ByUserId(0).then((userPreferenceResponse: any) => {
                if (userPreferenceResponse) {
                  localStorage.setItem('hideFilterDashboard', userPreferenceResponse.hideFilterDashboard.toString());
                  localStorage.setItem('homePagePreference', userPreferenceResponse.homePagePreference.toString());
                } else {
                  localStorage.setItem('hideFilterDashboard', 'false');
                  localStorage.setItem('homePagePreference', '0');
                }

                // Pega o valor do homePagePreference do localStorage
                const homePagePreference = localStorage.getItem('homePagePreference');
                const homePagePreferenceInt = parseInt(homePagePreference, 10);

                // Redireciona com base no valor de homePagePreference
                if (homePagePreferenceInt === 1) {
                  history.push('/DashboardBranch');
                } else {
                  if(response.result.user.profile.profileName === 'operator') {
                    history.push('/DashboardBranch');
                  } else {
                    history.push('/');
                  }
                }
              });
            } else {
              // Redireciona outros perfis de usuário que não são admin, core, ou ctry_admin
              if(response.result.user.profile.profileName === 'operator') {
                history.push('/DashboardBranch');
              } else {
                history.push('/ApproverPickup');
              }
            }
          }

        } else {
          let messages = response.messages?.find((value, index, object) => {
            return value.message === 'BAS_LOGIN';
          });
          if (messages) {
            setTimeout(() => {
              window.location.href = appsettings.BAS_URL;
            }, 3000)
          }
        }
      }).catch((e: any) => {
        ToastService.error(t('ERROR_GENERIC'));
      }).finally(() => {
        setLoading(false);
      });
  }

  const initialValues: UserCredentialsModel = {
    login: '',
    password: ''
  };

  const schema = yup.object().shape({
    login: yup.string().required(t('REQUIRED')).email(t('EMAIL_VALIDATION')),
    password: yup.string().required(t('REQUIRED'))
  });

  useEffect(() => {
    setLoading(true);
    BdpVersionService
      .getVersion()
      .then((response: ResultRequestModel) => {
        if (response.success) {
          var item: BdpVersionModel[] = null
          item = [{ id: '', descricao: "" }];

          let data = response.result;

          setFrontVersion(VERSION_FRONT);
          setBancoVersion(data.db_version);
          setBackVersion(data.back_version);
          setSprintVersion(data.sprint_version);

          setAlertVersion(item.filter((m) => m.id !== ''));
          setLoaded(true);
        }
      }).catch((e: any) => {
        ToastService.error(t('ERROR_GENERIC'));
      }).finally(() => {
        setLoading(false);
      });

  }, []);

  // Alteração no modelo de exibição do versionamento do front do back e da base de dados
  // Retorno no formato de data
  // retornos considerados
  // Front informado em variável 
  // back informado em variável
  // base de dados  gravado em tabela do banco

  function returnVersion() {
    if (loaded) {
      return (
        <div className="version-div">
          <span title={"Front - Sprint " + moment(front_Version).format("DDMM.HH")}>{moment(front_Version).format("DDMM.HH")}</span>. 
          <span title={"Front - Sprint " + moment(back_Version).format("DDMM.HH")}>{moment(back_Version).format("DDMM.HH")}</span>. 
          <span title={"Front - Sprint " + moment(banco_Version).format("DDMM.HH")}>{moment(banco_Version).format("DDMM.HH")}</span>. 
        </div>
      )
    }
  }

  return (<>
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={(values, actions) => {
        loginRequest(values);
      }}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        touched,
        isValid,
        errors,
      }) => (

        <Form noValidate onSubmit={handleSubmit}>
          <>

            {alertVersion
              .map((item, idx) => (
                <Alert
                  key={item.id}
                  variant="danger">
                  {item.descricao}
                </Alert>
              ))}
               {       /**
               * sprint3200
               * Mudando o visual do login
               */}

            <Form.Floating className="mb-2">
              <div className="mb-4">
                <h5 className="text-white" style={{ textAlign: 'left' }}>{t("PAGE_LOGIN.USER")}</h5>
                <Form.Control
                  id="login"
                  name="login"
                  type="email"
                  placeholder={t("PAGE_LOGIN.USER")}
                  value={values?.login}
                  onChange={handleChange}
                  disabled={isLoading}
                  isInvalid={touched.login && !!errors.login}
                  style={{ height: '48px' }} 
                />
                <Form.Control.Feedback type="invalid">
                  {errors.login}
                </Form.Control.Feedback>
              </div>
            </Form.Floating>

            <Form.Floating className="mb-2">
              <div className="mb-4">
                <h5 className="text-white" style={{ textAlign: 'left' }}>{t("PAGE_LOGIN.PASSWORD")}</h5>
                <Form.Control
                  id="password"
                  name="password"
                  type="password"
                  placeholder={t("PAGE_LOGIN.PASSWORD")}
                  value={values?.password}
                  onChange={handleChange}
                  disabled={isLoading}
                  isInvalid={touched.password && !!errors.password}
                  style={{ height: '48px' }} 
                />
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </div>
            </Form.Floating>
            {/* Botões de login e esqueceu a senha */}
            <Row className="justify-content-center">
              <Col xs={12} sm={12} className="mb-1">
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isLoading}
                  className="w-100"
                  style={{ backgroundColor: '#000038', borderColor: '#000038', height: '56px' }}
                >
                  {isLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="mr-1"
                    />
                  ) : null}
                  {t("PAGE_LOGIN.BUTTON_LOGIN")}
                </Button>
              </Col>

            </Row>
            <Row className="justify-content-center">
              <Col xs={12} sm={12}>
                <Button
                  variant="link"
                  disabled={isLoading}
                  onClick={() => { history.push('/ForgotPassword') }}
                  className="w-100 text-center"
                  style={{ color: '#ffffff' }}
                >
                  {t("PAGE_LOGIN.FORGOT_PASSWORD")}
                </Button>
              </Col>
            </Row>
            {returnVersion()}
          </>
        </Form>
      )}
    </Formik>
    <CustomModal
      Title={t("MODULE_ALERT.ATTENTION")}
      Message={showWarning ? (showWarning.params[0] < 0 ? t("PASS_EXPIRED_MESSAGE").replace("%DAYS%", moment().add(showWarning.params[0], 'day').format("DD/MM/YYYY")) : t("PASS_TO_EXPIRE_MESSAGE").replace("%DAYS%", showWarning.params[0])) : ""}
      close={handleCloseWarning}
      show={showWarning ? showWarning.show : false}>

      <Button variant='primary' onClick={ChangePassword}>
        {t('YES')}
      </Button>
      <Button variant='primary' onClick={handleCloseWarning}>
        {t('NO')}
      </Button>
    </CustomModal>
    <ModalChangePassword
      Title={t("BUTTON_CHANGE_PASSWORD")}
      Message="WIP"
      cancel={t('CANCEL')}
      close={handleClosePasswordChanging}
      show={showModalChangePassword} />
  </>
  );
};
export default Login;
